// plugins/notifications.js
import { ref, markRaw } from 'vue';
import Notification from '@/components/Notification.vue';

export default {
    install(app) {
        // Реактивное хранилище сообщений
        const notificationData = ref({
            show: false,
            message: '',
        });

        // Глобальная функция для показа уведомлений
        function notify(message) {
            notificationData.value.show = true;
            notificationData.value.message = message;

            // Автоматическое закрытие уведомления спустя 3 секунды
            setTimeout(() => {
                notificationData.value.show = false;
                notificationData.value.message = '';
            }, 3000);
        }

        // Экспортируем функциональность через Provide / Inject
        app.provide('notificationData', notificationData);
        app.provide('notify', notify);

        // Компонент регистрируется глобально
        app.component('Notification', markRaw(Notification)); // предотвращаем лишние рекурсивные обходы дерева
    },
};
